function video() {
    window.addEventListener('DOMContentLoaded', function() {
        var videoContainers = document.querySelectorAll('.local-video-container');
        
        videoContainers.forEach(function(container) {
          var video = container.querySelector('video');
          var startTime = container.dataset.startTime;
          var stopTime = container.dataset.stopTime;
      
          video.currentTime = startTime;
      
          video.addEventListener('timeupdate', function() {
            if (video.currentTime >= stopTime) {
              if (video.loop) {
                video.currentTime = startTime;
              } else {
                video.pause();
              }
            }
          });
        });
      });
      
    }
    export default {
      init: function () {
        video();
      }
    };
    